<div [formGroup]="form" class="mt-2">
  <p class="text-sm text-gray-500 mb-4" *ngIf="modo === 'crear'">
    Todos los documentos, la ubicación y el punto en el mapa (GPS) son obligatorios para registrar al colaborador.
  </p>
  <p class="text-sm text-gray-500 mb-4" *ngIf="modo === 'editar'">
    Los documentos ya cargados se muestran abajo (podés descargarlos). Para <b>reemplazar</b> uno, elegí un archivo nuevo; los que no toques se conservan. Si no cambiás nada, el expediente actual queda igual.
  </p>

  <!-- Archivos -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
    <div>
      <label class="text-gray-700 text-sm font-medium">RIF <b class="text-red-500" *ngIf="modo === 'crear'">*</b> <span class="text-gray-400 text-xs">(PDF/PNG/JPG)</span></label>
      <input type="file" accept=".pdf,image/png,image/jpeg" class="inputTextoDialog focusCampo !h-10 p-2" (change)="onArchivoSeleccionado($event, 'rifFile')" />
      <p *ngIf="archivosDoc['rifFile']" class="text-green-600 text-xs mt-1">✓ {{ archivosDoc['rifFile'].name }} (nuevo)</p>
      <p *ngIf="!archivosDoc['rifFile'] && existentes['rifFile']" class="text-xs mt-1 text-blue-600">
        📎 <a class="underline cursor-pointer" (click)="descargarExistente('rifFile')">{{ existentes['rifFile']!.name }}</a>
        <span *ngIf="descargando['rifFile']" class="text-gray-400">· descargando…</span>
      </p>
    </div>
    <div>
      <label class="text-gray-700 text-sm font-medium">Cédula <b class="text-red-500" *ngIf="modo === 'crear'">*</b> <span class="text-gray-400 text-xs">(PDF/PNG/JPG)</span></label>
      <input type="file" accept=".pdf,image/png,image/jpeg" class="inputTextoDialog focusCampo !h-10 p-2" (change)="onArchivoSeleccionado($event, 'cedula')" />
      <p *ngIf="archivosDoc['cedula']" class="text-green-600 text-xs mt-1">✓ {{ archivosDoc['cedula'].name }} (nuevo)</p>
      <p *ngIf="!archivosDoc['cedula'] && existentes['cedula']" class="text-xs mt-1 text-blue-600">
        📎 <a class="underline cursor-pointer" (click)="descargarExistente('cedula')">{{ existentes['cedula']!.name }}</a>
        <span *ngIf="descargando['cedula']" class="text-gray-400">· descargando…</span>
      </p>
    </div>
    <div>
      <label class="text-gray-700 text-sm font-medium">Currículum (CV) <b class="text-red-500" *ngIf="modo === 'crear'">*</b> <span class="text-gray-400 text-xs">(solo PDF)</span></label>
      <input type="file" accept=".pdf" class="inputTextoDialog focusCampo !h-10 p-2" (change)="onArchivoSeleccionado($event, 'cv')" />
      <p *ngIf="archivosDoc['cv']" class="text-green-600 text-xs mt-1">✓ {{ archivosDoc['cv'].name }} (nuevo)</p>
      <p *ngIf="!archivosDoc['cv'] && existentes['cv']" class="text-xs mt-1 text-blue-600">
        📎 <a class="underline cursor-pointer" (click)="descargarExistente('cv')">{{ existentes['cv']!.name }}</a>
        <span *ngIf="descargando['cv']" class="text-gray-400">· descargando…</span>
      </p>
    </div>
    <div>
      <label class="text-gray-700 text-sm font-medium">Foto carnet <b class="text-red-500" *ngIf="modo === 'crear'">*</b> <span class="text-gray-400 text-xs">(PNG/JPG)</span></label>
      <input type="file" accept="image/png,image/jpeg" class="inputTextoDialog focusCampo !h-10 p-2" (change)="onArchivoSeleccionado($event, 'carnetFoto')" />
      <p *ngIf="archivosDoc['carnetFoto']" class="text-green-600 text-xs mt-1">✓ {{ archivosDoc['carnetFoto'].name }} (nuevo)</p>
      <p *ngIf="!archivosDoc['carnetFoto'] && existentes['carnetFoto']" class="text-xs mt-1 text-blue-600">
        📎 <a class="underline cursor-pointer" (click)="descargarExistente('carnetFoto')">{{ existentes['carnetFoto']!.name }}</a>
        <span *ngIf="descargando['carnetFoto']" class="text-gray-400">· descargando…</span>
      </p>
    </div>
    <div>
      <label class="text-gray-700 text-sm font-medium">Foto oficina <b class="text-red-500" *ngIf="modo === 'crear'">*</b> <span class="text-gray-400 text-xs">(PNG/JPG)</span></label>
      <input type="file" accept="image/png,image/jpeg" class="inputTextoDialog focusCampo !h-10 p-2" (change)="onArchivoSeleccionado($event, 'oficioFoto')" />
      <p *ngIf="archivosDoc['oficioFoto']" class="text-green-600 text-xs mt-1">✓ {{ archivosDoc['oficioFoto'].name }} (nuevo)</p>
      <p *ngIf="!archivosDoc['oficioFoto'] && existentes['oficioFoto']" class="text-xs mt-1 text-blue-600">
        📎 <a class="underline cursor-pointer" (click)="descargarExistente('oficioFoto')">{{ existentes['oficioFoto']!.name }}</a>
        <span *ngIf="descargando['oficioFoto']" class="text-gray-400">· descargando…</span>
      </p>
    </div>
    <div>
      <label class="text-gray-700 text-sm font-medium">Tipo de sangre</label>
      <select formControlName="frmBloodType" class="inputTextoDialog focusCampo !h-10">
        <option value="">Seleccionar</option>
        <option *ngFor="let bt of bloodTypes" [value]="bt">{{ bt }}</option>
      </select>
    </div>
  </div>

  <!-- Ubicación -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
    <div>
      <label class="text-gray-700 text-sm font-medium">Estado <b class="text-red-500" *ngIf="modo === 'crear'">*</b></label>
      <input type="text" class="inputTextoDialog focusCampo !h-10 p-2.5" formControlName="frmEstado" />
    </div>
    <div>
      <label class="text-gray-700 text-sm font-medium">Ciudad <b class="text-red-500" *ngIf="modo === 'crear'">*</b></label>
      <input type="text" class="inputTextoDialog focusCampo !h-10 p-2.5" formControlName="frmCiudad" (blur)="buscarEnMapa(true)" />
    </div>
    <div class="md:col-span-2">
      <label class="text-gray-700 text-sm font-medium">Dirección de la oficina <b class="text-red-500" *ngIf="modo === 'crear'">*</b></label>
      <textarea rows="2" maxlength="255" class="inputTextoDialog focusCampo p-2.5" formControlName="frmOficioAddress" (blur)="buscarEnMapa(true)"></textarea>
    </div>
  </div>

  <!-- Mapa -->
  <div class="mt-4">
    <div class="flex items-center justify-between flex-wrap gap-2">
      <label class="text-gray-700 text-sm font-medium">Ubicación en el mapa (o haga clic para fijar el punto) <b class="text-red-500" *ngIf="modo === 'crear'">*</b></label>
      <button type="button"
        class="text-sm px-3 py-1.5 rounded-md border border-teal-500 text-teal-700 hover:bg-teal-50 disabled:opacity-50 disabled:cursor-not-allowed"
        (click)="buscarEnMapa(false)" [disabled]="geocodificando">
        <span *ngIf="!geocodificando">📍 Buscar dirección en el mapa</span>
        <span *ngIf="geocodificando">Buscando…</span>
      </button>
    </div>
    <div [id]="mapId" class="w-full h-72 rounded-lg border border-gray-300 mt-1" style="z-index:0;"></div>
    <p class="text-xs mt-1" [ngClass]="form.value.frmGpsLat != null ? 'text-green-600' : 'text-gray-500'">
      {{ form.value.frmGpsLat != null
          ? '✓ GPS: ' + form.value.frmGpsLat + ', ' + form.value.frmGpsLng
          : 'Sin coordenadas seleccionadas' }}
    </p>
  </div>
</div>
